import { Box, Typography } from '@mui/material'
import React from 'react'
import InputController from '../../../../components/InputController/InputController'
import DatePickerController from '../../../../components/CustomDatepicker/CustomDatePicker';

import { ParentContainerSection } from '../DiabeticForm';
const IdentifyingSection = (props) => {
    const { control, errors, getValues } = props
  return (
    <ParentContainerSection  heading="Section A - Identifying Data">
     <Box sx={{display: "flex",  gap:"0.5rem", flexWrap: "wrap", mb: "1rem"}}>
          <InputController
                                    name="patient_name"
                                    label="Patient Name"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    // icon={<HotelRoundedIcon/>}
                            />  


          <InputController
                                    name="patient_gender"
                                    label="Sex"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    // icon={<WcRoundedIcon/>}
                            />  
          <InputController
                                    name="cmis_number"
                                    label="ID/CMIS Number"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    // icon={<VerifiedRoundedIcon/>}
                            />  

<DatePickerController name="patient_dob"
                             label="DOB"
                              control={control}
                               errors={errors}
                                readOnly={true}
                                 />
                                 </Box>
    </ParentContainerSection>

  )
}

export default IdentifyingSection